function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200px",
    height: "200px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.956
    },
    fill: "#3e61c7",
    d: "M 87.5,-0.5 C 88.1667,-0.5 88.8333,-0.5 89.5,-0.5C 89.5,5.16667 89.5,10.8333 89.5,16.5C 87.8828,17.038 86.2161,17.3713 84.5,17.5C 84.5,11.8333 84.5,6.16667 84.5,0.5C 85.791,0.737305 86.791,0.403972 87.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.961
    },
    fill: "#3d60c8",
    d: "M 89.5,-0.5 C 91.5,-0.5 93.5,-0.5 95.5,-0.5C 95.5,4.83333 95.5,10.1667 95.5,15.5C 93.5648,16.1495 91.5648,16.4828 89.5,16.5C 89.5,10.8333 89.5,5.16667 89.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.985
    },
    fill: "#3d5cc8",
    d: "M 95.5,-0.5 C 97.8333,-0.5 100.167,-0.5 102.5,-0.5C 102.5,4.83333 102.5,10.1667 102.5,15.5C 100.167,15.5 97.8333,15.5 95.5,15.5C 95.5,10.1667 95.5,4.83333 95.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#3b56c8",
    d: "M 102.5,-0.5 C 103.833,-0.5 105.167,-0.5 106.5,-0.5C 106.5,5.16667 106.5,10.8333 106.5,16.5C 105.292,15.7659 103.959,15.4326 102.5,15.5C 102.5,10.1667 102.5,4.83333 102.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.947
    },
    fill: "#3c53c7",
    d: "M 106.5,-0.5 C 108.167,-0.5 109.833,-0.5 111.5,-0.5C 111.5,-0.166667 111.5,0.166667 111.5,0.5C 111.5,5.83333 111.5,11.1667 111.5,16.5C 109.833,16.5 108.167,16.5 106.5,16.5C 106.5,10.8333 106.5,5.16667 106.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.937
    },
    fill: "#3f67c7",
    d: "M 84.5,0.5 C 84.5,6.16667 84.5,11.8333 84.5,17.5C 78.9533,19.6067 73.62,22.2733 68.5,25.5C 68.5,19.1667 68.5,12.8333 68.5,6.5C 73.381,3.53635 78.7143,1.53635 84.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.941
    },
    fill: "#394dc7",
    d: "M 111.5,0.5 C 113.415,0.215521 115.081,0.548855 116.5,1.5C 116.5,7.16667 116.5,12.8333 116.5,18.5C 114.597,18.2041 112.93,17.5375 111.5,16.5C 111.5,11.1667 111.5,5.83333 111.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.946
    },
    fill: "#3948c7",
    d: "M 116.5,1.5 C 118.099,1.23219 119.432,1.56552 120.5,2.5C 120.786,8.25858 120.452,13.9252 119.5,19.5C 118.391,19.4431 117.391,19.1098 116.5,18.5C 116.5,12.8333 116.5,7.16667 116.5,1.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.931
    },
    fill: "#3845c7",
    d: "M 120.5,2.5 C 121.791,2.26269 122.791,2.59603 123.5,3.5C 123.5,9.5 123.5,15.5 123.5,21.5C 122.167,20.8333 120.833,20.1667 119.5,19.5C 120.452,13.9252 120.786,8.25858 120.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.944
    },
    fill: "#3740c7",
    d: "M 123.5,3.5 C 125.703,3.60357 127.703,4.27024 129.5,5.5C 129.5,11.8333 129.5,18.1667 129.5,24.5C 127.5,23.5 125.5,22.5 123.5,21.5C 123.5,15.5 123.5,9.5 123.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.941
    },
    fill: "#363cc7",
    d: "M 129.5,5.5 C 131.368,6.26315 133.035,7.26315 134.5,8.5C 134.5,15.1667 134.5,21.8333 134.5,28.5C 132.809,27.1363 131.142,25.803 129.5,24.5C 129.5,18.1667 129.5,11.8333 129.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.93
    },
    fill: "#3f6dc7",
    d: "M 68.5,6.5 C 68.5,12.8333 68.5,19.1667 68.5,25.5C 65.1667,28.5 61.8333,31.5 58.5,34.5C 58.5,27.1667 58.5,19.8333 58.5,12.5C 61.1612,9.4977 64.4945,7.4977 68.5,6.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.917
    },
    fill: "#3635c6",
    d: "M 134.5,8.5 C 138.025,9.75889 141.025,11.7589 143.5,14.5C 142.508,21.6476 142.175,28.9809 142.5,36.5C 139.5,34.1667 136.833,31.5 134.5,28.5C 134.5,21.8333 134.5,15.1667 134.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.928
    },
    fill: "#4073c6",
    d: "M 58.5,12.5 C 58.5,19.8333 58.5,27.1667 58.5,34.5C 41.2066,58.1514 41.2066,81.818 58.5,105.5C 58.5,113.833 58.5,122.167 58.5,130.5C 53.84,124.839 49.1734,119.172 44.5,113.5C 44.5,84.1667 44.5,54.8333 44.5,25.5C 47.9331,19.7928 52.5998,15.4594 58.5,12.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.931
    },
    fill: "#3b33c5",
    d: "M 143.5,14.5 C 147.104,16.288 149.77,18.9547 151.5,22.5C 151.5,32.8333 151.5,43.1667 151.5,53.5C 148.786,47.7412 145.786,42.0745 142.5,36.5C 142.175,28.9809 142.508,21.6476 143.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.962
    },
    fill: "#4132c5",
    d: "M 151.5,22.5 C 155.99,26.3261 159.323,30.9927 161.5,36.5C 161.5,58.8333 161.5,81.1667 161.5,103.5C 159.237,108.365 156.237,112.698 152.5,116.5C 151.506,106.681 151.173,96.6806 151.5,86.5C 154.126,75.4927 154.126,64.4927 151.5,53.5C 151.5,43.1667 151.5,32.8333 151.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.953
    },
    fill: "#4278c4",
    d: "M 44.5,25.5 C 44.5,54.8333 44.5,84.1667 44.5,113.5C 33.8626,100.934 28.5292,86.2678 28.5,69.5C 28.8245,52.8806 34.1579,38.214 44.5,25.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.89
    },
    fill: "#4485c3",
    d: "M 14.5,29.5 C 14.5,34.8333 14.5,40.1667 14.5,45.5C 8.7215,46.4268 5.38817,43.7601 4.5,37.5C 5.13672,31.5346 8.47005,28.8679 14.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.861
    },
    fill: "#4381c4",
    d: "M 14.5,29.5 C 19.1666,30.3388 21.5,33.1722 21.5,38C 21.0095,42.3213 18.6762,44.8213 14.5,45.5C 14.5,40.1667 14.5,34.8333 14.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.92
    },
    fill: "#542dc4",
    d: "M 190.5,30.5 C 189.203,35.2669 189.203,39.9335 190.5,44.5C 183.77,47.6272 179.437,45.4606 177.5,38C 178.795,30.3502 183.128,27.8502 190.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.832
    },
    fill: "#592cc4",
    d: "M 190.5,30.5 C 195.833,35.1667 195.833,39.8333 190.5,44.5C 189.203,39.9335 189.203,35.2669 190.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.927
    },
    fill: "#4730c5",
    d: "M 161.5,36.5 C 170.521,52.8317 172.688,70.165 168,88.5C 166.684,93.9728 164.518,98.9728 161.5,103.5C 161.5,81.1667 161.5,58.8333 161.5,36.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.907
    },
    fill: "#4386c3",
    d: "M -0.5,74.5 C -0.5,71.5 -0.5,68.5 -0.5,65.5C 4.05461,60.7112 8.88794,60.3778 14,64.5C 17.4151,75.4169 13.5818,79.5836 2.5,77C 1.62656,75.955 0.626561,75.1217 -0.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.902
    },
    fill: "#3f65c7",
    d: "M 84.5,61.5 C 84.5,68.1667 84.5,74.8333 84.5,81.5C 79.9395,78.6145 76.9395,74.6145 75.5,69.5C 75.9849,64.0155 78.9849,61.3489 84.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.958
    },
    fill: "#3e61c7",
    d: "M 84.5,61.5 C 86.5138,61.3915 88.1805,62.0582 89.5,63.5C 89.5,71.1667 89.5,78.8333 89.5,86.5C 87.5,85.1667 85.8333,83.5 84.5,81.5C 84.5,74.8333 84.5,68.1667 84.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.949
    },
    fill: "#394dc7",
    d: "M 116.5,61.5 C 116.5,67.5 116.5,73.5 116.5,79.5C 115.167,81.5 113.5,83.1667 111.5,84.5C 111.825,77.3134 111.491,70.3134 110.5,63.5C 111.99,61.7202 113.99,61.0535 116.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.933
    },
    fill: "#3948c7",
    d: "M 116.5,61.5 C 118.153,61.6596 119.486,62.3263 120.5,63.5C 120.5,67.5 120.5,71.5 120.5,75.5C 119.5,77.1667 118.167,78.5 116.5,79.5C 116.5,73.5 116.5,67.5 116.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.862
    },
    fill: "#562dc4",
    d: "M 189.5,61.5 C 189.5,66.8333 189.5,72.1667 189.5,77.5C 185.26,76.8744 183.26,74.3744 183.5,70C 183.42,65.6492 185.42,62.8159 189.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.929
    },
    fill: "#5a2cc4",
    d: "M 189.5,61.5 C 193.532,61.1856 196.865,62.5189 199.5,65.5C 199.5,68.5 199.5,71.5 199.5,74.5C 196.606,77.5817 193.272,78.5817 189.5,77.5C 189.5,72.1667 189.5,66.8333 189.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.94
    },
    fill: "#3d60c8",
    d: "M 89.5,63.5 C 92.1667,65.5 94.5,67.8333 96.5,70.5C 95.5046,82.989 95.1713,95.6557 95.5,108.5C 94.2058,107.71 93.0391,106.71 92,105.5C 91.6667,99.8333 91.3333,94.1667 91,88.5C 90.2828,87.9558 89.7828,87.2891 89.5,86.5C 89.5,78.8333 89.5,71.1667 89.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.959
    },
    fill: "#3c53c7",
    d: "M 110.5,63.5 C 111.491,70.3134 111.825,77.3134 111.5,84.5C 110.542,85.9616 109.376,87.2949 108,88.5C 107.501,93.4889 107.334,98.4889 107.5,103.5C 106.505,91.3446 106.171,79.0113 106.5,66.5C 107.262,64.7376 108.596,63.7376 110.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.755
    },
    fill: "#3845c7",
    d: "M 120.5,63.5 C 122.533,64.8984 123.533,66.8984 123.5,69.5C 123.533,72.1016 122.533,74.1016 120.5,75.5C 120.5,71.5 120.5,67.5 120.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.946
    },
    fill: "#3b56c8",
    d: "M 106.5,66.5 C 106.171,79.0113 106.505,91.3446 107.5,103.5C 106.833,106.167 105.167,107.833 102.5,108.5C 102.5,95.8333 102.5,83.1667 102.5,70.5C 103.5,68.8333 104.833,67.5 106.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.958
    },
    fill: "#3c5cc8",
    d: "M 96.5,70.5 C 97.4822,71.1408 98.4822,71.8075 99.5,72.5C 100.518,71.8075 101.518,71.1408 102.5,70.5C 102.5,83.1667 102.5,95.8333 102.5,108.5C 100.274,109.756 97.941,109.756 95.5,108.5C 95.1713,95.6557 95.5046,82.989 96.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.932
    },
    fill: "#3b33c5",
    d: "M 151.5,86.5 C 151.173,96.6806 151.506,106.681 152.5,116.5C 149.5,119.833 146.5,123.167 143.5,126.5C 142.508,118.684 142.174,110.684 142.5,102.5C 146.036,97.4233 149.036,92.0899 151.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.88
    },
    fill: "#4485c3",
    d: "M 14.5,93.5 C 14.1786,99.0262 14.5119,104.36 15.5,109.5C 9.4507,111.002 5.78404,108.502 4.5,102C 4.91487,95.7527 8.24821,92.9194 14.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.871
    },
    fill: "#4381c4",
    d: "M 14.5,93.5 C 18.8061,94.5684 21.1394,97.4018 21.5,102C 21.1209,105.872 19.1209,108.372 15.5,109.5C 14.5119,104.36 14.1786,99.0262 14.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.912
    },
    fill: "#542dc4",
    d: "M 190.5,94.5 C 189.203,99.2669 189.203,103.934 190.5,108.5C 183.74,111.788 179.406,109.621 177.5,102C 179.064,94.5908 183.397,92.0908 190.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.845
    },
    fill: "#592cc4",
    d: "M 190.5,94.5 C 194.455,97.774 195.289,101.774 193,106.5C 192.292,107.381 191.458,108.047 190.5,108.5C 189.203,103.934 189.203,99.2669 190.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.942
    },
    fill: "#3636c6",
    d: "M 142.5,102.5 C 142.174,110.684 142.508,118.684 143.5,126.5C 140.71,133.111 138.043,139.778 135.5,146.5C 134.505,135.012 134.172,123.345 134.5,111.5C 137.195,108.474 139.862,105.474 142.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.954
    },
    fill: "#3f6cc7",
    d: "M 58.5,105.5 C 62.1667,108.5 65.5,111.833 68.5,115.5C 68.8283,127.345 68.4949,139.012 67.5,150.5C 61.8274,145.147 58.8274,138.48 58.5,130.5C 58.5,122.167 58.5,113.833 58.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.951
    },
    fill: "#363cc7",
    d: "M 134.5,111.5 C 134.172,123.345 134.505,135.012 135.5,146.5C 134.089,148.914 132.089,150.581 129.5,151.5C 129.5,140.167 129.5,128.833 129.5,117.5C 130.419,114.911 132.086,112.911 134.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.938
    },
    fill: "#3f67c7",
    d: "M 68.5,115.5 C 72.967,121.711 75.8004,128.711 77,136.5C 78.995,138.747 81.495,139.747 84.5,139.5C 84.5,145.167 84.5,150.833 84.5,156.5C 78.0265,156.455 72.3599,154.455 67.5,150.5C 68.4949,139.012 68.8283,127.345 68.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.943
    },
    fill: "#3740c7",
    d: "M 129.5,117.5 C 129.5,128.833 129.5,140.167 129.5,151.5C 128.089,153.539 126.089,154.539 123.5,154.5C 123.5,147.5 123.5,140.5 123.5,133.5C 123.75,127.407 125.75,122.074 129.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.935
    },
    fill: "#3845c7",
    d: "M 123.5,133.5 C 123.5,140.5 123.5,147.5 123.5,154.5C 122.791,155.404 121.791,155.737 120.5,155.5C 120.786,149.741 120.452,144.075 119.5,138.5C 121.539,137.328 122.872,135.662 123.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.948
    },
    fill: "#3948c7",
    d: "M 119.5,138.5 C 120.452,144.075 120.786,149.741 120.5,155.5C 119.292,156.234 117.959,156.567 116.5,156.5C 116.5,150.833 116.5,145.167 116.5,139.5C 117.609,139.443 118.609,139.11 119.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.927
    },
    fill: "#3e61c7",
    d: "M 84.5,139.5 C 86.1667,139.5 87.8333,139.5 89.5,139.5C 89.5,145.167 89.5,150.833 89.5,156.5C 87.8333,156.5 86.1667,156.5 84.5,156.5C 84.5,150.833 84.5,145.167 84.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.927
    },
    fill: "#3d60c8",
    d: "M 89.5,139.5 C 91.5,139.5 93.5,139.5 95.5,139.5C 95.5,145.167 95.5,150.833 95.5,156.5C 93.5,156.5 91.5,156.5 89.5,156.5C 89.5,150.833 89.5,145.167 89.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.927
    },
    fill: "#3d5cc8",
    d: "M 95.5,139.5 C 97.8333,139.5 100.167,139.5 102.5,139.5C 102.5,145.167 102.5,150.833 102.5,156.5C 100.167,156.5 97.8333,156.5 95.5,156.5C 95.5,150.833 95.5,145.167 95.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.927
    },
    fill: "#3b56c8",
    d: "M 102.5,139.5 C 103.833,139.5 105.167,139.5 106.5,139.5C 106.5,145.167 106.5,150.833 106.5,156.5C 105.167,156.5 103.833,156.5 102.5,156.5C 102.5,150.833 102.5,145.167 102.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.927
    },
    fill: "#3c53c7",
    d: "M 106.5,139.5 C 108.167,139.5 109.833,139.5 111.5,139.5C 111.5,145.167 111.5,150.833 111.5,156.5C 109.833,156.5 108.167,156.5 106.5,156.5C 106.5,150.833 106.5,145.167 106.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.927
    },
    fill: "#394dc7",
    d: "M 111.5,139.5 C 113.167,139.5 114.833,139.5 116.5,139.5C 116.5,145.167 116.5,150.833 116.5,156.5C 114.833,156.5 113.167,156.5 111.5,156.5C 111.5,150.833 111.5,145.167 111.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.903
    },
    fill: "#3f65c7",
    d: "M 84.5,167.5 C 84.5,176.5 84.5,185.5 84.5,194.5C 76.4593,188.055 74.126,180.055 77.5,170.5C 79.4872,168.673 81.8205,167.673 84.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.955
    },
    fill: "#3e61c7",
    d: "M 84.5,167.5 C 86.674,167.75 88.3406,168.75 89.5,170.5C 89.5,179.5 89.5,188.5 89.5,197.5C 87.326,197.25 85.6594,196.25 84.5,194.5C 84.5,185.5 84.5,176.5 84.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#394dc7",
    d: "M 116.5,167.5 C 116.5,175.833 116.5,184.167 116.5,192.5C 115.415,194.587 113.749,195.92 111.5,196.5C 111.827,187.318 111.493,178.318 110.5,169.5C 112.102,167.926 114.102,167.259 116.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.943
    },
    fill: "#3948c7",
    d: "M 116.5,167.5 C 117.833,168.167 119.167,168.833 120.5,169.5C 120.5,175.167 120.5,180.833 120.5,186.5C 120.155,189.198 118.822,191.198 116.5,192.5C 116.5,184.167 116.5,175.833 116.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.943
    },
    fill: "#3c53c7",
    d: "M 110.5,169.5 C 111.493,178.318 111.827,187.318 111.5,196.5C 110.22,197.931 108.553,198.598 106.5,198.5C 106.5,192.167 106.5,185.833 106.5,179.5C 105.75,175.225 107.083,171.891 110.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75
    },
    fill: "#3845c7",
    d: "M 120.5,169.5 C 122.894,171.332 123.894,173.832 123.5,177C 123.573,180.61 122.573,183.777 120.5,186.5C 120.5,180.833 120.5,175.167 120.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.928
    },
    fill: "#3d60c8",
    d: "M 89.5,170.5 C 91.5038,174.457 93.5038,178.457 95.5,182.5C 95.5,188.167 95.5,193.833 95.5,199.5C 94.5,199.5 93.5,199.5 92.5,199.5C 91.5,198.833 90.5,198.167 89.5,197.5C 89.5,188.5 89.5,179.5 89.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.944
    },
    fill: "#3b56c8",
    d: "M 106.5,179.5 C 106.5,185.833 106.5,192.167 106.5,198.5C 106.5,198.833 106.5,199.167 106.5,199.5C 105.167,199.5 103.833,199.5 102.5,199.5C 102.5,193.833 102.5,188.167 102.5,182.5C 103.833,181.5 105.167,180.5 106.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.976
    },
    fill: "#3c5cc8",
    d: "M 95.5,182.5 C 97.8744,183.686 100.208,183.686 102.5,182.5C 102.5,188.167 102.5,193.833 102.5,199.5C 100.167,199.5 97.8333,199.5 95.5,199.5C 95.5,193.833 95.5,188.167 95.5,182.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.96dffc79b22334a29d3fdbfec0edf2e6.svg";
export { ForwardRef as ReactComponent };